import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import { ChevronDown } from "lucide-react";

const accent = "#D9B8CE";

export default function FAQ2() {
	const { t } = useTranslation();
	const [openIndex, setOpenIndex] = useState(null);

	const items = Array.from({ length: 7 }, (_, i) => ({
		question: t(`salon2.faq.items.${i}.question`),
		answer: t(`salon2.faq.items.${i}.answer`),
	}));

	const toggle = (index) => {
		setOpenIndex(openIndex === index ? null : index);
	};

	return (
		<section
			id="faq"
			className="py-24 bg-white overflow-hidden"
			style={{ fontFamily: "'Poppins', sans-serif" }}
		>
			<div className="max-w-3xl mx-auto px-6 lg:px-16">
				{/* Header */}
				<motion.div
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.7, ease: "easeOut" }}
					viewport={{ once: true }}
					className="text-center mb-14"
				>
					<p
						className="uppercase tracking-wider text-sm font-semibold mb-3"
						style={{ color: accent }}
					>
						{t("salon2.faq.badge")}
					</p>
					<h2
						style={{
							fontSize: "clamp(1.8rem, 5vw, 2.8rem)",
							fontWeight: 800,
							color: "#222",
						}}
					>
						{t("salon2.faq.title")}
					</h2>
				</motion.div>

				{/* Accordion */}
				<div className="space-y-3">
					{items.map((item, i) => (
						<motion.div
							key={i}
							initial={{ opacity: 0, y: 15 }}
							whileInView={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.4, delay: i * 0.05 }}
							viewport={{ once: true }}
							className="rounded-xl border border-gray-100 overflow-hidden"
							style={{
								boxShadow:
									openIndex === i
										? "0 8px 30px rgba(217,184,206,0.12)"
										: "0 4px 16px rgba(0,0,0,0.02)",
								transition: "box-shadow 0.3s ease",
							}}
						>
							{/* Question */}
							<button
								onClick={() => toggle(i)}
								className="w-full flex items-center justify-between px-6 py-5 text-left bg-white hover:bg-gray-50/60 transition-colors duration-200"
							>
								<span
									className="font-semibold pr-4"
									style={{
										color: openIndex === i ? "#1a1a1a" : "#333",
										fontSize: "1.02rem",
									}}
								>
									{item.question}
								</span>
								<motion.span
									animate={{ rotate: openIndex === i ? 180 : 0 }}
									transition={{ duration: 0.3 }}
									className="flex-shrink-0"
								>
									<ChevronDown
										size={20}
										style={{
											color: openIndex === i ? accent : "#999",
										}}
									/>
								</motion.span>
							</button>

							{/* Answer */}
							<AnimatePresence initial={false}>
								{openIndex === i && (
									<motion.div
										initial={{ height: 0 }}
										animate={{ height: "auto" }}
										exit={{ height: 0 }}
										transition={{ duration: 0.25, ease: "easeOut" }}
										className="overflow-hidden"
									>
										<div
											className="px-6 pb-5 leading-relaxed"
											style={{
												color: "#555",
												fontSize: "0.95rem",
												borderTop: "1px solid #f3f3f3",
												paddingTop: "1rem",
											}}
										>
											{item.answer}
										</div>
									</motion.div>
								)}
							</AnimatePresence>
						</motion.div>
					))}
				</div>
			</div>
		</section>
	);
}
